exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".body-content[data-v-7721080e]{height:50vh}.body-content .bm-view[data-v-7721080e]{width:100%;height:100%}.body-content .bm-view[data-v-7721080e] .BMap_Marker img{width:100%;height:100%;object-fit:contain}\n", ""]);

// exports
